<script setup>
import {computed, onMounted, onUnmounted, ref} from 'vue';

const props = defineProps({
    align: {
        type: String,
        default: 'right',
    },
    width: {
        type: String,
        default: '48',
    },
    contentClasses: {
        type: Array,
        default: () => ['py-1', 'bg-white dark:bg-dark-blue'],
    },
});

const emits = defineEmits(['open', 'close'])

let open = ref(false);

const closeOnEscape = (e) => {
    if (open.value && e.key === 'Escape') {
        closeMenu()
    }
};

const openMenu = () => {
        open.value = true;
        emits('open')
    },
    closeMenu = () => {
        open.value = false;
        emits('close')
    }

onMounted(() => {
    if (typeof document !== 'undefined') {
        document.addEventListener('keydown', closeOnEscape);
    }
});
onUnmounted(() => {
    if (typeof document !== 'undefined') {
        document.removeEventListener('keydown', closeOnEscape);
    }
});

const widthClass = computed(() => {
    return {
        'auto': 'w-auto',
        '48': 'w-48',
    }[props.width.toString()];
});

const alignmentClasses = computed(() => {
    if (props.align === 'left') {
        return 'origin-top-left left-0';
    }

    if (props.align === 'right') {
        return 'origin-top-right right-0';
    }

    return 'origin-top';
});
</script>

<template>
    <div class="relative">
        <div @click="open ? closeMenu() : openMenu()">
            <slot name="trigger" :open="open"/>
        </div>

        <!-- Full Screen Dropdown Overlay -->
        <div v-show="open" class="fixed inset-0 z-40" @click="closeMenu()"/>

        <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div
                v-show="open"
                class="absolute z-50 mt-2 rounded-md shadow-lg"
                :class="[widthClass, alignmentClasses]"
                style="display: none;"
                @click="closeMenu()"
            >
                <div class="rounded-md ring-1 dark:bg-deep-blue ring-black/5 dark:ring-slate-200/5" :class="contentClasses">
                    <slot name="content"/>
                </div>
            </div>
        </transition>
    </div>
</template>
